import { render, staticRenderFns } from "./HotChartsPopup.vue?vue&type=template&id=72143bce&scoped=true"
import script from "./HotChartsPopup.vue?vue&type=script&lang=js"
export * from "./HotChartsPopup.vue?vue&type=script&lang=js"
import style0 from "./HotChartsPopup.vue?vue&type=style&index=0&id=72143bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72143bce",
  null
  
)

export default component.exports